import React from 'react';
import { Table, TableRow, TableHeaderCell } from 'semantic-ui-react';

export default class PrintSprayWorksheetProductsTableHeader extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <Table.Header>
                <TableRow>
                    <TableHeaderCell>Chemical</TableHeaderCell>
                    <TableHeaderCell>Rate/100L</TableHeaderCell>
                    <TableHeaderCell>Rate/Ha</TableHeaderCell>
                    <TableHeaderCell>Rate/tank</TableHeaderCell>
                    <TableHeaderCell>Water rate</TableHeaderCell>
                    <TableHeaderCell>Order</TableHeaderCell>
                    <TableHeaderCell>REP</TableHeaderCell>
                    <TableHeaderCell>WHP</TableHeaderCell>
                </TableRow>
            </Table.Header>
        );
    }
}
